import { type StateCreator } from 'zustand';

export type Profile = {
  name: string;
  email: string;
  address: string;
  phone_number: string;
  role: string;
  business: UserBusiness;
  bank: UserBank;
  is_login_otp_enabled: boolean;
  is_group: boolean;
};

export interface UserBusiness {
  name: string;
  address: string;
  country: string;
  country_code: string;
  phone_number: string;
  email: string;
  website: string;
  merchant_type: string;
  is_approved: boolean;
  status: string;
  logo_path: string;
  primary_color: string;
  secondary_color: string;
  header_title: string;
  button_color: string;
  button_text_color: string;
  sidebar_text_color: string;
  sidebar_text_secondary_color: string;
  theme_name: string;
  image?: string;
  province: string;
  city: string;
  is_main_business?: boolean;
}

export interface UserBank {
  name: string;
  bank_code: string;
  account_number: string;
  account_beneficiary: string;
}

export type ProfileSlice = {
  profile: Profile | null;
  setProfile: (profile: Profile) => void;
};

export const createProfileSlice: StateCreator<ProfileSlice, [], [], ProfileSlice> = (set) => ({
  profile: null,
  setProfile: (profile) => set({ profile }),
});
